import type { Customer } from '../types/models';

export const FUEL_TYPES = ['Petrol', 'Diesel', 'Electric', 'Hybrid'];
export const TRANSMISSIONS = ['Manual', 'Automatic'];

export function pickerOptions(baseOptions: string[], currentValue: string) {
  const seen = new Set<string>();
  const options: string[] = [];

  function append(value: string) {
    const cleaned = value.trim();
    if (!seen.has(cleaned)) {
      seen.add(cleaned);
      options.push(cleaned);
    }
  }

  if (!currentValue.trim()) append('');
  baseOptions.forEach(append);
  if (currentValue.trim()) append(currentValue);

  return options;
}

export function customerPickerTitle(customer: Customer): string {
  const name = customer.name?.trim() ?? '';
  const nickname = customer.nickname?.trim() ?? '';
  if (nickname && nickname.toLowerCase() !== name.toLowerCase()) {
    return `${nickname} - ${name}`;
  }
  return name;
}
